import Vue from 'vue'
import initVueApp from '@/init'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import VueGtag from 'vue-gtag'

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueGtag, {
    config: {id: process.env.VUE_APP_GA_ID}
  }, router)
}

initVueApp()

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
